import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';

type Props = {
    sellerName: string;
    showSendSellerMessageModal: () => void;
};

const DeclineMessage = ({ sellerName, showSendSellerMessageModal }: Props) => {
    return (
        <FormattedMessage
            id="registration.declined_format"
            values={{
                houseName: sellerName,
                link: (
                    <ShouldLogInContainer
                        key="decline-message-link"
                        requireCompleteProfile
                        requireLogin
                        runFunction={showSendSellerMessageModal}
                    >
                        <Link>
                            <FormattedMessage id="send_message" />
                        </Link>
                    </ShouldLogInContainer>
                ),
            }}
        />
    );
};

export default React.memo<Props>(DeclineMessage, isEqual);
